/*!
 * vue-permissions v0.10.14 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { renderSlim, makeF, mergeContext } from '@aspectus/vue-utils';
import { hasAccess } from '@aspectus/permissions';
import { Tag } from '@aspectus/vue-tag';

var PermissionsAccessState = {
  name: 'permissions-access-state',
  props: {
    permissions: Array
  },
  data: function data() {
    return {
      hasAccess: false
    };
  },
  watch: {
    permissions: {
      immediate: true,
      handler: 'setAccess'
    }
  },
  methods: {
    setAccess: function setAccess() {
      var _this = this;

      var permissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.permissions;
      hasAccess(permissions || [], this).then(function () {
        return _this.hasAccess = true;
      }) // eslint-disable-line no-return-assign
      .catch(function () {
        return _this.hasAccess = false;
      }); // eslint-disable-line no-return-assign
    }
  },
  render: function render(h) {
    return renderSlim(this.$scopedSlots.default({
      hasAccess: this.hasAccess
    }) || [], h, Tag, {
      attrs: this.$attrs,
      on: this.$listeners
    });
  }
};

/* eslint-disable prefer-object-spread */
var PermissionsAvailable = makeF(function (h, context) {
  return h(context.props.checker, mergeContext(context.data, {
    scopedSlots: {
      default: function _default(_ref) {
        var hasAccess = _ref.hasAccess;
        return hasAccess ? context.scopedSlots.default({
          hasAccess: hasAccess
        }) : [h(null)];
      }
    }
  }));
}, {
  checker: {
    default: function _default() {
      return PermissionsAccessState;
    }
  }
}, 'permissions-available');

function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stateName = _ref.stateName,
      stateName = _ref$stateName === void 0 ? PermissionsAccessState.name : _ref$stateName,
      _ref$availableName = _ref.availableName,
      availableName = _ref$availableName === void 0 ? PermissionsAvailable.name : _ref$availableName;

  Vue.component(stateName, PermissionsAccessState);
  Vue.component(availableName, PermissionsAvailable);
}

var main = {
  install: install
};

export default main;
export { PermissionsAccessState, PermissionsAvailable };
